import type { CourseModule } from "@/core/types";
import { lektionHyperlinks } from "./lektion-01-hyperlinks";
import { lektionTextmarken } from "./lektion-02-textmarken";
import { lektionSymboleFormeln } from "./lektion-03-symbole-formeln";
import { lektionTextfelder } from "./lektion-04-textfelder";
import { lektionDeckblatt } from "./lektion-05-deckblatt";

/**
 * Die Registerkarte „Einfügen“ jenseits von Tabellen und Bildern.
 *
 * Deckblatt und Formel zeigen sich nur im OOXML, Initialen und
 * Schnellbausteine gar nicht in Office.js – dort prüft ein VBA-Prüfmakro.
 */
export const modulEinfuegen: CourseModule = {
  id: "einfuegen",
  title: "Links, Textmarken und Objekte",
  summary:
    "Hyperlinks mit sprechendem Text, Textmarken, Symbole, Formeln, Textfelder, " +
    "Initialen, Datumsfelder, Deckblätter und eigene Schnellbausteine.",
  level: "Grundlagen",
  lessons: [lektionHyperlinks, lektionTextmarken, lektionSymboleFormeln, lektionTextfelder, lektionDeckblatt],
};
